"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconButton = _interopRequireDefault(require("../../Buttons/IconButton"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _ModalWrapper = require("./ModalWrapper.styles");

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * This is just a simple modal base class.
 */
var ModalWrapper = function ModalWrapper(_ref) {
  var _inStyleGuide = _ref._inStyleGuide,
      children = _ref.children,
      className = _ref.className,
      closeHandler = _ref.closeHandler,
      dataTestId = _ref.dataTestId,
      isOpen = _ref.isOpen,
      modalRole = _ref.modalRole,
      title = _ref.title,
      topBar = _ref.topBar,
      props = _objectWithoutProperties(_ref, ["_inStyleGuide", "children", "className", "closeHandler", "dataTestId", "isOpen", "modalRole", "title", "topBar"]);

  return isOpen ? /*#__PURE__*/_react.default.createElement(_ModalWrapper.StyledModalWrapper, {
    className: ['c-modal-wrapper-modal-wrapper', _inStyleGuide && 'c-modal-wrapper-in-style-guide', className].join(' '),
    "data-test-id": dataTestId,
    modalRole: modalRole
  }, !_inStyleGuide && /*#__PURE__*/_react.default.createElement(_ModalWrapper.LockBackground, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "centering-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", _extends({
    className: ['c-modal-wrapper-modal', modalRole === 'alertChoice' ? 'c-modal-wrapper-alert-choice' : undefined, 'test'].join(' ')
  }, props), topBar && /*#__PURE__*/_react.default.createElement("div", {
    className: "c-modal-wrapper-modal-header",
    "data-test-id": "modal-wrapper-modal-header"
  }, modalRole === 'alert' && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: "c-modal-wrapper-top-bar-icon",
    dataTestId: "modal-wrapper-top-bar-icon",
    iconName: "exclamation-triangle",
    size: "mediumLarge",
    colorTheme: "overDark"
  }), modalRole === 'info' && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: "c-modal-wrapper-top-bar-icon",
    dataTestId: "modal-wrapper-top-bar-icon",
    iconName: "info-circle",
    size: "mediumLarge",
    colorTheme: "overDark"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "c-modal-wrapper-title",
    "data-test-id": "modal-wrapper-title"
  }, title), modalRole === 'default' && /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: ['c-modal-wrapper-top-bar-icon', 'c-modal-wrapper-close-button'].join(' '),
    dataTestId: "modal-wrapper-close-button",
    onClick: closeHandler,
    iconName: "times",
    size: "small",
    colorTheme: "overDark"
  })), typeof children === 'string' ? /*#__PURE__*/_react.default.createElement("div", {
    className: "c-modal-wrapper-modal-content",
    "data-test-id": "modal-wrapper-modal-content",
    dangerouslySetInnerHTML: {
      __html: children
    }
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "c-modal-wrapper-modal-content",
    "data-test-id": "modal-wrapper-modal-content"
  }, children)))) : null;
};

ModalWrapper.propTypes = {
  /** Any valid HTML nodes or React components - though typical use is text */
  children: _propTypes2.default.children.isRequired,

  /** Additional classname */
  className: _propTypes.PropTypes.string,

  /** method to invoke as a close handler */
  closeHandler: _propTypes.PropTypes.func,

  /** Test ID hook */
  dataTestId: _propTypes.PropTypes.string.isRequired,

  /** control flag for display */
  isOpen: _propTypes.PropTypes.bool,

  /** The role of the modal which affects styling and classes */
  modalRole: _propTypes.PropTypes.string,

  /** the title for the modal */
  title: _propTypes.PropTypes.string,

  /** include the default top bar */
  topBar: _propTypes.PropTypes.bool,

  /** A flag specifically for the styleguide - used to turn off fixed positioning */
  _inStyleGuide: _propTypes.PropTypes.bool
};
ModalWrapper.defaultProps = {
  className: '',
  closeHandler: function closeHandler() {
    console.error('Please provide a close handler if using the provided close button.');
  },
  // eslint-disable-line no-console
  isOpen: false,
  modalRole: 'default',
  title: '',
  topBar: true,
  _inStyleGuide: false
};
var _default = ModalWrapper;
exports.default = _default;